import {Component, OnInit} from '@angular/core';
import {filter, take, tap} from 'rxjs/operators';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from '../menu/navigator';
import { MenuController } from '@ionic/angular';
import { LoyaltyProgramProvider } from 'src/app/services/loyalty-program/loyalty-program.service';

@Component({
  selector: 'app-loyalty-rewards-card',
  templateUrl: './loyalty-rewards-card-component.html'
})
export class LoyaltyRewardsCardComponent implements OnInit {
  isCardConnected: boolean;
  boydCardImage: string;
  connectedCardImg: string;
  isAuthenticated = false;
  tierLevel: any;

  connectedCardImgCheckmark: string;
  constructor(
    // private boydRewardsService: BoydRewardsService,
    // private menuStateService: MenuStat,
    private userSessionService: UserSessionService,
    public utils: UtilsService,
    public navigator: Navigator,
    public menuCtrl: MenuController,
    private loyaltyProgramProvider: LoyaltyProgramProvider,

  ) {
    this.loyaltyProgramProvider.cardConnectEvent.addListener("Card Status Update", (arg)=> this.isCardConnected = arg);
  }



  checkConnectionToBoydCard() {
    this.loyaltyProgramProvider.getLoyaltyCard().subscribe((res) => {
      (res.result == 1 && res.payload == true) ? this.isCardConnected = true : this.isCardConnected = false;
    })
  }

  ngOnInit(): void {
    this.userSessionService
      .getCustomer()
      .pipe(
        filter(customer => !!customer),
        take(1),
        tap(() => this.checkConnectionToBoydCard())
      )
      .subscribe();

    }

  public changeBoydCardtext() {
    if (this.isCardConnected) {
      this.boydCardImage = this.utils.getCDNAsset('icon/card-connected.svg');
    } else {
      this.boydCardImage = this.utils.getCDNAsset(
        'icon/card-not-connected.svg'
      );
    }
  }

  connectBoydCard() {
    this.menuCtrl.close();
    this.navigator.navigateTo('LoyaltyProgramPage');
  }
}
